import { render, staticRenderFns } from "./listLocationsSellers.vue?vue&type=template&id=b2541f14&scoped=true&"
import script from "./listLocationsSellers.vue?vue&type=script&lang=js&"
export * from "./listLocationsSellers.vue?vue&type=script&lang=js&"
import style0 from "./listLocationsSellers.vue?vue&type=style&index=0&id=b2541f14&prod&scoped=true&lang=css&"
import style1 from "./listLocationsSellers.vue?vue&type=style&index=1&id=b2541f14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2541f14",
  null
  
)

export default component.exports